import { IRequesterInfo } from '../../../../../base/models'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'

export class SendNoPicturesApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/noPictureMail',
      requesterInfo,
    })
  }

  // Mails boş bırakılırsa koddaki varsayılan adreslere gönderilir.
  public async sendNoPicturesMail(req?: { CompId?: number; Mails?: string[] }): Promise<any> {
    return await this.postAsync<any>(req)
  }
}
